import React from "react";

interface ILoadingSpinnerProps {
  size: "small" | "medium" | "large" | "xlarge";
  className?: string;
}

const LoadingSpinner = ({ size, className }: ILoadingSpinnerProps) => {
  let sizeClasses;
  switch (size) {
    case "small":
      sizeClasses = "w-16 h-16";
      break;
    case "medium":
      sizeClasses = "w-24 h-24";
      break;
    case "large":
      sizeClasses = "w-36 h-36";
      break;
    case "xlarge":
      sizeClasses = "w-40 h-40";
      break;
  }

  const classes =
    sizeClasses +
    " border-4 border-grey-400 border-b-grey-600 rounded-full animate-spin " +
    className;
  return (
    <div className="flex items-center justify-center ">
      <div className={classes}></div>
    </div>
  );
};

export default LoadingSpinner;
